import { render, staticRenderFns } from "./MinhasLicitacoesFavoritas.vue?vue&type=template&id=0eb749a0"
import script from "./MinhasLicitacoesFavoritas.vue?vue&type=script&lang=js"
export * from "./MinhasLicitacoesFavoritas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports